import { BaseDto } from './base.dto';
import { CustomerAddressDto } from './customerAddress.dto';
import { CustomerFavoriteDto } from './customerFavorite.dto';
import { CustomerPaymentTypeDto } from './customerPaymentType.dto';
import { GiftCardDto } from './gift-card';
import { OrderDto } from './order.dto';

export class CustomerDto extends BaseDto {
  fullName: string;
  email: string;
  password: string;
  phoneNumber: string;
  phoneAreaCode?: string;
  photoURL: string;
  profileImageURL?: string;
  createdDate?: Date;
  acceptedTermsDate: Date;
  deleted: boolean;
  deletedDate?: Date;
  modifiedDate?: Date;
  customerAddress?: CustomerAddressDto[];
  orders?: OrderDto[];
  customerPaymentMethods?: CustomerPaymentTypeDto[];
  customerFBId?: string;
  active?: boolean;
  paymentMethodId?: number;
  customerFavorites?: CustomerFavoriteDto[];
  gender?: string;
  dateOfBirth?: Date;
  acceptsMarketingTerms?: boolean;
  giftCards?: GiftCardDto[];
  firstName?: string;
  lastName?: string;
  qrCode?: string;
  totalLoyaltyPoints?: number;
  tags?: string;
}
